import { Component, Input, inject } from '@angular/core';
import { VariablesService } from '@services/variables/variables.service';
import { VwoService } from '@services/vwo/vwo.service';
import { ThankyouSuccessHeadComponent } from '../thankyou-success-head/thankyou-success-head.component';
import { ThankyouTestimonialsComponent } from '../thankyou-testimonials/thankyou-testimonials.component';
import { FaqsComponent } from '../faqs/faqs.component';
import { DonorsSliderComponent } from '../donors-slider/donors-slider.component';
import { TrustedByComponent } from '../trusted-by/trusted-by.component';
import { SipMonthPlanV3Component } from '../sip-month-plan-v3/sip-month-plan-v3.component';
import { SipStaticImpactComponent } from '../sip-static-impact/sip-static-impact.component';

@Component({
  selector: 'app-impact-signup-card-v6',
  standalone: true,
  imports: [
    ThankyouSuccessHeadComponent,
    SipMonthPlanV3Component,
    ThankyouTestimonialsComponent,
    DonorsSliderComponent,
    TrustedByComponent,
    SipStaticImpactComponent,
    FaqsComponent
  ],
  templateUrl: './impact-signup-card-v6.component.html',
  styleUrls: ['./impact-signup-card-v6.component.scss']
})
export class ImpactSignupCardV6Component {

  readonly vars = inject(VariablesService);
  readonly vwo = inject(VwoService);

  @Input() config;
  supporterImg;

  ngOnInit() {
    this.vars.layoutConfig.next({
      showHeader: false,
      showFooter: false,
      hideAbandonedCart: true
    });
  }

}
